import DownloadCard from './DownloadCard/DownloadCard';
import type { DownloadLinkProps } from './types/propsTypes';
import styles from './DownloadLink.module.scss';

const DownloadLink = (props: DownloadLinkProps) => (
  <div className={styles['downloadlink-container']} data-testid={'downloadlink-tabs-test-id'}>
    {props.data?.map((cart) => (
      <DownloadCard key={`${cart.label}${cart.url}`} label={cart.label} url={cart.url} target={cart.target} />
    ))}
  </div>
);

export default DownloadLink;
